import Link from "next/link"
import { ReactNode, useMemo } from "react"
import LogoImage from "../images/LogoImage"
import { BodyDefaultLight, Heading1, Heading2, Heading3 } from "../text"
import Section from "./Section"
type GenericSectionImages = {
  side?: "left" | "right"
  caption?: string
  images: {
    url: string
    src: string
    svg?: string
    alt: string
    order: number
    slug: string
  }[]
}

type GenericSectionProps = {
  header?: {
    text?: string
    type?: "h1" | "h2" | "h3"
  }
  images: GenericSectionImages
  content?: ReactNode
  button?: ReactNode
  headerSubtitle?: ReactNode
}

const GenericSectionImageGrid: React.FC<GenericSectionProps> = (props) => {
  const { header, content, images, button, headerSubtitle: HeaderSubtitle } = props
  const HeaderTag = useMemo(() => {
    switch (header?.type) {
      case "h1":
        return Heading1
      case "h2":
        return Heading2
      case "h3":
        return Heading3
      default:
        return Heading2
    }
  }, [header?.type])

  return (
    <Section className="mx-auto max-w-2xl md:max-w-4xl lg:max-w-7xl text-left">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div
          className={`
          order-1 
          ${images.side === "right" ? "lg:order-1" : "lg:order-2"}
        `}>
          {HeaderSubtitle}
          {!!header?.text && <HeaderTag className="mb-[1.5rem]">{header.text}</HeaderTag>}
          {content}
          {button}
        </div>
        <div
          className={`
          order-2 
          ${images.side === "right" ? "lg:order-2" : "lg:order-1"}
        `}>
          <div className="relative aspect-[4/3] w-full">
            <ImageGrid images={images} />
            <BodyDefaultLight className="text-gray-80 mt-4 text-center">{images.caption}</BodyDefaultLight>
          </div>
        </div>
      </div>
    </Section>
  )
}

const ImageGrid: React.FC<{ images: GenericSectionImages }> = ({ images }) => {
  const sortedImages = [...images.images].sort((a, b) => a.order - b.order)
  return (
    <div className="relative aspect-[4/3] w-full grid grid-cols-2 items-center">
      {!!sortedImages.length &&
        sortedImages.map((image, index) => (
          <Link href={`goede-doelen/${image.slug}`} key={index}>
            <LogoImage
              src={image.svg ?? image.src}
              height={72}
              width={182}
              alt={image.alt}
              className="max-w-[200px] max-h-[120px]  mx-auto p-6"
            />
          </Link>
        ))}
    </div>
  )
}

export default GenericSectionImageGrid
